import React from "react";
import Box from "../Box";
import styled from "styled-components";
import SelectBar from "../SelectBar";
import { useOptionRegion } from "../../utils/options";

type RegionTempoProps = {
  children: React.ReactNode;
};

const BoxContainer = styled(Box)<{ gap: number }>`
  gap: ${(props) => `${props.gap}px`};
`;

const RegionTempo = ({ children }: RegionTempoProps) => {

  const regionOptions = useOptionRegion();

  return (
    <>
      { regionOptions.length > 0 && (
        <BoxContainer
          gap={10}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
        >
          <Box>
            <SelectBar options={regionOptions} backgroundColor="#f4f4f4" />
          </Box>
          <Box>
            {children}
          </Box>
        </BoxContainer>    
      )}
    </>
  );
};

export default RegionTempo;
